import React from 'react'

import WiderButton from './WiderButton'
import { contactHeaderItems } from './contactHeaderItems'

const ContactHeader: React.FC = () => {
  const { linkButtons } = contactHeaderItems

  return (
    <div className="switcher">
      <div className="switcher">
        {linkButtons.map((linkButton, index) => (
          <WiderButton {...linkButton} key={index} />
        ))}
      </div>

      <div></div>
    </div>
  )
}

export default ContactHeader
